import {
    IS_TRANS_LOADING,
    IS_CONSTRAINTS_LOADING,
    TRANS_HAS_ERROR,
    TRANS_FETCH_DATA_SUCCESS,
    CONSTRAINTS_SUCCESS,
    CONSTRAINTS_HAS_ERROR,
    RESET_API_ERROR,
    IS_RULES_LOADING,
    RULES_FETCH_DATA_SUCCESS,
    RULES_HAS_ERROR,
    SET_TOTAL_POINTS,
    LANDING_TRANS_LOADING,
    LANDING_TRANS_SUCCESS,
    LANDING_TRANS_ERROR,
    CLOSE_DYNAMIC_CARD,
} from './../constants/action-types';
import common from "../common";
import config from "../config"

const initialState = {
    isTransLoading: false,
    isConstraintsLoading: false,
    trans: {},
    hasError: false,
    constraints: {},
    userData: null,
    isRulesLoading: false,
    rulesData: {},
    rulesHasError: false,
    totalScore: common.getLocalStorage('totalScore') || null,
    dynamicCards: [],
};
export default function appData(state = initialState, action) {
    switch (action.type) {
        case IS_TRANS_LOADING: {
            return { ...state, isTransLoading: action.payload };
        }
        case IS_CONSTRAINTS_LOADING: {
            return { ...state, isConstraintsLoading: action.payload };
        }
        case TRANS_HAS_ERROR: {
            return { ...state, hasError: action.payload };
        }
        case TRANS_FETCH_DATA_SUCCESS: {
            return { ...state, trans: action.payload['Data']['Value']['Translation'] };
        }
        case CONSTRAINTS_HAS_ERROR: {
            return { ...state, hasError: action.payload };
        }
        case CONSTRAINTS_SUCCESS: {
            if (action.payload['Data']['Value']['PriceFilter']) {
                config.priceFilter = common.setPriceFilterArrays(action.payload['Data']['Value']['PriceFilter'], 'priceFilter');
                config.priceFilterObj = common.setPriceFilterArrays(action.payload['Data']['Value']['PriceFilter'], 'priceFilterObj');
            } else {
                config.priceFilter = [
                    { id: 100, label: 'Unlimited', min: 0, max: 100, trackingKey: "Unlimited" },
                    { id: 101, label: 'Affordable', min: 0, max: 0, trackingKey: "Affordable" },
                    { id: 18, label: '€13', min: 13, max: 100, trackingKey: "€13" },
                    { id: 17, label: '€12.5', min: 12.5, max: 100, trackingKey: '€12.5' },
                    { id: 16, label: '€12', min: 12, max: 100, trackingKey: '€12' },
                    { id: 15, label: '€11.5', min: 11.5, max: 100, trackingKey: '€11.5' },
                    { id: 14, label: '€11', min: 11, max: 100, trackingKey: '€11' },
                    { id: 13, label: '€10.5', min: 10.5, max: 100, trackingKey: '€10.5' },
                    { id: 12, label: '€10', min: 10, max: 100, trackingKey: '€10' },
                    { id: 11, label: '€9.5', min: 9.5, max: 100, trackingKey: '€9.5' },
                    { id: 10, label: '€9', min: 9, max: 100, trackingKey: '€9' },
                    { id: 9, label: '€8.5', min: 8.5, max: 100, trackingKey: '€8.5' },
                    { id: 8, label: '€8', min: 8, max: 100, trackingKey: '€8' },
                    { id: 7, label: '€7.5', min: 7.5, max: 100, trackingKey: '€7.5' },
                    { id: 6, label: '€7', min: 7, max: 100, trackingKey: '€7' },
                    { id: 5, label: '€6.5', min: 6.5, max: 100, trackingKey: '€6.5' },
                    { id: 4, label: '€6', min: 6, max: 100, trackingKey: '€6' },
                    { id: 3, label: '€5.5', min: 5.5, max: 100, trackingKey: '€5.5' },
                    { id: 2, label: '€5', min: 5, max: 8.9, trackingKey: '€5' },
                    { id: 1, label: '€4.5', min: 4.5, max: 6.9, trackingKey: '€4.5' },
                    { id: 0, label: '€4', min: 4, max: 4.9, trackingKey: '€4' },


                ];
                config.priceFilterObj = {
                    100: { id: 100, label: 'Unlimited', min: 0, max: 100, trackingKey: "Unlimited" },
                    101: { id: 101, label: 'Affordable', min: 0, max: 0, trackingKey: "Affordable" },
                    18: { id: 18, label: '€13', min: 13, max: 100, trackingKey: "€13" },
                    17: { id: 17, label: '€12.5', min: 12.5, max: 100, trackingKey: "€12.5" },
                    16: { id: 16, label: '€12', min: 12, max: 100, trackingKey: "€12" },
                    15: { id: 15, label: '€11.5', min: 11.5, max: 100, trackingKey: "€11.5" },
                    14: { id: 14, label: '€11', min: 11, max: 100, trackingKey: "€11" },
                    13: { id: 13, label: '€10.5', min: 10.5, max: 100, trackingKey: "€10.5" },
                    12: { id: 12, label: '€10', min: 10, max: 100, trackingKey: "€10" },
                    11: { id: 11, label: '€9.5', min: 9.5, max: 100, trackingKey: "€9.5" },
                    10: { id: 10, label: '€9', min: 9, max: 100, trackingKey: "€9" },
                    9: { id: 9, label: '€8.5', min: 8.5, max: 100, trackingKey: "€8.5" },
                    8: { id: 8, label: '€8', min: 8, max: 100, trackingKey: "€8" },
                    7: { id: 7, label: '€7.5', min: 7.5, max: 100, trackingKey: "€7.5" },
                    6: { id: 6, label: '€7', min: 7, max: 100, trackingKey: "€7" },
                    5: { id: 5, label: '€6.5', min: 6.5, max: 100, trackingKey: "€6.5" },
                    4: { id: 4, label: '€6', min: 6, max: 100, trackingKey: "€6" },
                    3: { id: 3, label: '€5.5', min: 5.5, max: 100, trackingKey: "€5.5" },
                    2: { id: 2, label: '€5', min: 5, max: 8.9, trackingKey: "€5" },
                    1: { id: 1, label: '€4.5', min: 4.5, max: 6.9, trackingKey: "€4.5" },
                    0: { id: 0, label: '€4', min: 4, max: 4.9, trackingKey: "€4" },
                };
            }
            
            
            let dynamicCards = action.payload['Data']['Value'].DynamicCard || [];
            dynamicCards.map((dynamicCard, index) => {
              let cardStatus = common.getLocalStorage('dynamicCard');
              if (!cardStatus) {
                let cardArray = [];
                if (dynamicCard.isDismissible) {
                  let cardObject = {
                    persistKey: dynamicCard.persistKey,
                    version: dynamicCard.version,
                    isDisabled: false,
                  };
                  cardArray.push(cardObject);
                  common.setLocalStorage('dynamicCard', cardArray);
                  dynamicCard.isDisabled = false;
                }
              } else {
                if (dynamicCard.isDismissible) {
                  let objIndex = cardStatus.findIndex(
                    (card) => card.persistKey === dynamicCard.persistKey
                  );
                  if (objIndex < 0) {
                    let cardObject = {
                      persistKey: dynamicCard.persistKey,
                      version: dynamicCard.version,
                      isDisabled: false,
                    };
                    cardStatus.push(cardObject);
                    common.setLocalStorage('dynamicCard', cardStatus);
                    dynamicCard.isDisabled = false;
                  } else {
                    if (cardStatus[objIndex].version !== dynamicCard.version) {
                      let cardObject = {
                        persistKey: dynamicCard.persistKey,
                        version: dynamicCard.version,
                        isDisabled: false,
                      };
                      cardStatus[objIndex] = cardObject;
                      common.setLocalStorage('dynamicCard', cardStatus);
                      dynamicCard.isDisabled = false;
                    } else {
                      dynamicCard.isDisabled = false;
                    }
                  }
                }
              }
            });
            
            let cardStatus = common.getLocalStorage('dynamicCard');
            if (cardStatus) {
              cardStatus.forEach(card => {
                let objIndex = dynamicCards.findIndex(
                  (dynamicCard) =>
                    card.persistKey === dynamicCard.persistKey &&
                    card.version === dynamicCard.version
                );
                dynamicCards[objIndex].isDisabled = card.isDisabled;
                
              });
            }
            
            return {
              ...state,
              constraints: action.payload['Data']['Value'],
              dynamicCards: dynamicCards,
            };
        }
        
        case CLOSE_DYNAMIC_CARD: {
          let cardStatus = common.getLocalStorage('dynamicCard');
          let objIndex = cardStatus.findIndex(
            (card) =>
              card.persistKey === action.payload.persistKey &&
              card.version === action.payload.version
          );
          if (objIndex >= 0) {
            cardStatus[objIndex].isDisabled = true;
            common.setLocalStorage('dynamicCard', cardStatus);
          }
          
          let dynamicCards = state.dynamicCards;
          cardStatus.forEach(card => {
            let objIndex = dynamicCards.findIndex(
              (dynamicCard) =>
                card.persistKey === dynamicCard.persistKey &&
                card.version === dynamicCard.version
            );
            dynamicCards[objIndex].isDisabled = card.isDisabled;
          });
          return {
            ...state,
            dynamicCards: [...dynamicCards],
          };
          
        }
        
        case RESET_API_ERROR: {
            return { ...state, hasError: false };
        }
        case IS_RULES_LOADING: {
            return { ...state, isRulesLoading: action.payload };
        }
        case RULES_FETCH_DATA_SUCCESS: {
            return { ...state, rulesData: action.payload };
        }
        case RULES_HAS_ERROR: {
            return { ...state, rulesHasError: action.payload };
        }
        case SET_TOTAL_POINTS: {
            if (action.payload) {
                common.setLocalStorage('totalScore', action.payload);
            }
            return { ...state, totalScore: action.payload };
        }
        case LANDING_TRANS_LOADING: {
            return { ...state, ladingTransLoading: true }
        }
        case LANDING_TRANS_SUCCESS: {
            return { ...state, landingTrans: action.payload['Data']['Value']['Translation'] }
        }
        case LANDING_TRANS_ERROR: {
            return { ...state, ladingTransError: true }
        }

        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js